const isDemo = process.env.REACT_APP_THEME === 'demo';

const styles = (theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    height: '100%',
    position: 'relative',
    fontFamily: isDemo ? 'inherit' : 'Questrial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    margin: 'auto',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  countChips: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    flexGrow: 1,
  },
  countChip: {
    marginRight: 8,
    marginBottom: 4,
  },
  // The theme's `secondary` is a very light teal with white contrastText, so
  // color="secondary" chips were unreadable (white on light teal). This gives the
  // "Needs attention" chip (header tally AND per-row state) a solid amber background
  // with white text for real contrast and a single consistent label/color.
  needsAttentionChip: {
    backgroundColor: '#D9700F',
    color: '#fff',
    '& span': { color: '#fff' },
  },
  // Performance-level chips (Approaches/Meets/Masters/Does Not Meet) take their
  // background from the shared STAAR palette via an inline style; this just forces
  // white label text for contrast on those colored backgrounds.
  levelChip: {
    color: '#fff',
    '& span': { color: '#fff' },
  },
  editSwitchWrap: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  bulkBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: 12,
    background: '#f3feff',
    borderRadius: 4,
    marginBottom: 12,
  },
  bulkSelect: {
    minWidth: 160,
    marginLeft: 12,
    marginRight: 12,
  },
  controlsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 12,
  },
  searchField: {
    minWidth: 220,
    marginRight: 12,
  },
  filterSelect: {
    minWidth: 180,
    marginRight: 12,
  },
  campusSelect: {
    minWidth: 200,
    marginRight: 12,
  },
  tableContainer: {
    width: '100%',
    flexGrow: 1,
    overflow: 'auto',
  },
  emptyFilterMsg: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: '32px 16px',
    color: '#888',
  },
  expandedCell: {
    background: '#f8feff',
    padding: 16,
  },
  editorGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  editorRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 16,
  },
  scoreField: {
    width: 150,
    marginRight: 16,
    marginBottom: 8,
  },
  assumedSelect: {
    minWidth: 180,
    marginRight: 16,
    marginBottom: 8,
  },
  noteField: {
    minWidth: 320,
    flexGrow: 1,
    marginBottom: 8,
  },
  editorActions: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    marginTop: 8,
  },
  helpText: {
    fontSize: '0.8rem',
    color: '#888',
    marginTop: 8,
  },
  clickableRow: {
    cursor: 'pointer',
  },
  uploadZone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    border: '2px dashed #b8d8de',
    borderRadius: 6,
    background: '#f8feff',
    padding: 20,
    marginBottom: 16,
    cursor: 'pointer',
    transition: 'background 0.15s ease, border-color 0.15s ease',
  },
  uploadZoneActive: {
    background: '#eef9fb',
    borderColor: '#4aa3b3',
  },
  uploadZoneBusy: {
    cursor: 'default',
    opacity: 0.7,
  },
  uploadTitle: {
    fontWeight: 600,
    marginBottom: 4,
  },
  uploadHint: {
    fontSize: '0.8rem',
    color: '#888',
  },
  uploadIcon: {
    fontSize: 28,
    color: '#4aa3b3',
    marginBottom: 4,
  },
  success: {
    backgroundColor: '#68D190',
  },
  error: {
    backgroundColor: '#FF5656',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: 20,
    marginRight: 8,
  },
});

export default styles;
